import { connect } from 'react-redux'
import { refreshCrop } from '../../actions/project/crop'
import CropImage from '../../components/CropImage'
import props from './mapStateToProps'

const mapStateToProps = state => ({
  ...props(state, window),
})
const bindDispatchToProps = dispatch => ({
  onChange: crop => dispatch(refreshCrop(crop)),
})

export default connect(
  mapStateToProps,
  bindDispatchToProps
)(CropImage)



// WEBPACK FOOTER //
// ./src/containers/CropImage/index.js